/**
 * @generated SignedSource<<abaff2dad0d9b41b7480b4486a74c3d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BurnedItemTileContent_nftItem$data = {
  readonly metadata: {
    readonly name?: string | null;
  } | null;
  readonly tokenId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTileItemDetails_nftItem">;
  readonly " $fragmentType": "BurnedItemTileContent_nftItem";
};
export type BurnedItemTileContent_nftItem$key = {
  readonly " $data"?: BurnedItemTileContent_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"BurnedItemTileContent_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BurnedItemTileContent_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tokenId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "type": "NftDigitalArtMetadata",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTileItemDetails_nftItem"
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "7efb312bfe45b79c01f9e133fd3a3adf";

export default node;
